/**!
 * @author ReeceM (iexistin3d)
 * @license Copyright Reece M
 * @version 1.0.0
 */

import axios from "axios";

export default class LockSession {
    intervalId = 0
    errors = 0
    constructor(interval = 30000) {
        if (!window.scriptVariables?.lockSessionUrl) {
            return
        }

        this.intervalId = setInterval(this.handler, interval);
    }

    handler() {

        if (!window.scriptVariables?.lockSessionUrl) {
            return
        }

        axios.post(window.scriptVariables.lockSessionUrl)
            .then(r => {
                if (r.status >= 200 && r.status < 300) {
                    this.errors = 0
                }
            })
            .catch(e => {
                console.error(e.message)
                if (this.errors >= 5) {
                    clearInterval(this.intervalId)
                    console.error('too many failed attempts to lock editing session, skipping')
                    console.debug(e)
                    return;
                }

                this.errors++
            })
    }
}
